import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container } from 'react-bootstrap';
import '../../../../../styles/diario.scss';
import { Link } from 'react-router-dom';



const FormBusca = (props) => {
    const [cargo, setCargo] = useState("");

    const handleChange = (e) => {
        const valor = e.target.value;
        setCargo(valor);
        props.filtrarLocalmente(valor); // ← filtragem instantânea
    };

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={2}>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="cargo">
                                <FloatingLabel label="Cargo" className="mb-3">
                                    <Form.Control
                                        type="text"
                                        value={cargo}
                                        onChange={handleChange}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>

                        <Col xs={6} lg={2}>
                            <Button
                                type="button"
                                variant="danger"
                                className="botao-alto"
                                onClick={() => { setCargo(""); props.fetchCargos(); }}
                            >
                                Limpar Busca
                            </Button>
                        </Col>
                        <Col xs={6} lg={2}>
                            <Link to={'/rh/cargos'}>
                                <Button variant="danger" className="botao-alto" type="button">
                                    Voltar
                                </Button>
                            </Link>
                        </Col>
                    </Row>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca
